module.exports = __webpack_public_path__ + "img/4.121377c6.png";